module.exports = "/images/66c0f5cd8223f1cb52f57a7bed51a735.svg";